import React, { useState, useMemo, lazy, Suspense } from "react";
import { Routes as Switch, Route, Navigate } from "react-router-dom";
import { UserContext } from "../services/Context/UserContext";
import IntakeFormQuestions from "../utils/intakeQuestionnaire.json";
import Spinner from "../components/Loader/Spinner";
const LoginForm = lazy(() => import("../pages/Login/LoginForm"));
const Newpass = lazy(() => import("../pages/Login/Newpass"));
const ForgotPass = lazy(() => import("../pages/Login/ForgotPass"));
const Terms = lazy(() => import("../pages/misc/Terms"));
const TwoFactorAuth = lazy(() => import("../pages/Login/TwoFactorAuth"));
const CancellationPolicyPage = lazy(() =>
  import("../pages/Dashboard/CancellationPolicyPage")
);

const AppointmentList = lazy(() =>
  import("../pages/MaanayaPages/Appointment/index")
);
const ViewAppointment = lazy(() =>
  import("../pages/MaanayaPages/Appointment/ViewAppointment")
);
const ViewRating = lazy(() =>
  import("../pages/Dashboard/ViewRating")
);
const Session = lazy(() =>
  import("../pages/Dashboard/Session")
);
const Profile = lazy(() =>
  import("../pages/Dashboard/Profile")
);

const NewRouters = lazy(() =>
  import("../pages/NewScreening/NewRouters")
);

const ThankYouPage = lazy(() =>
  import("../pages/ThankYouPage/ThankYouPage")
);

const ProviderInfoPage = lazy(() =>
  import("../pages/CareTeam/careTeamPages").then(
    (module) => ({ default: module.ProviderInfoPage })
  )
);

const DetailPhysicianPage = lazy(() =>
  import("../pages/CareTeam/careTeamPages").then(
    (module) => ({ default: module.DetailPhysicianPage })
  )
);

const AvailabilityPage = lazy(() =>
  import("../pages/CareTeam/careTeamPages").then(
    (module) => ({ default: module.AvailabilityPage })
  )
);

const PaymentPage = lazy(() =>
  import("../pages/CareTeam/careTeamPages").then(
    (module) => ({ default: module.PaymentPage })
  )
);

const SuccessPage = lazy(() =>
  import("../pages/CareTeam/careTeamPages").then(
    (module) => ({ default: module.SuccessPage })
  )
);
// import Profile from "../pages/Profile/Profile"


const Routes = () => {
  const [userInfo, setuserInfo] = useState({
    auth: localStorage.getItem("token") ? true : false,
    personalRecord: {
      "First Name": "",
      "Middle Name": "",
      "Last Name": "",
      Gender: "none",
      "Phone Number": "",
      profile: "",
      DOB: "",
      Email: "",
      Password: "",
      "Confirm Password": "",
      Address: "",
      Timezone: "none",
      State: "",
      long: 75.26589,
      lat: 34.98765,
    },
    medicalRecord: {

      medicalQuestions: window.location.href
        .split("://")[1]
        .startsWith("menthealth")
        ? IntakeFormQuestions?.businessTypes?.mentalhealth?.intakeQuestionnaire?.map(
          (quest) => ({ question: quest?.question, answer: "" }),
        )
        : window.location.href.split("://")[1].startsWith("medhealth")
          ? IntakeFormQuestions?.businessTypes?.healthcare?.intakeQuestionnaire?.map(
            (quest) => ({ question: quest?.question, answer: "" }),
          )
          :
          IntakeFormQuestions?.businessTypes?.marijuna?.intakeQuestionnaire?.map(
            (quest) => ({ question: quest?.question, answer: "" }),
          ),
    },
  });

  const ProviderValue = useMemo(
    () => ({ userInfo, setuserInfo }),
    [userInfo, setuserInfo],
  );

  return (
    <Suspense
      fallback={
        <div className="h-full flex items-center justify-center">
          <Spinner />
        </div>
      }
    >
      <Switch>
        <Route
          path="/login"
          element={
            <UserContext.Provider value={ProviderValue}>
              <LoginForm />
            </UserContext.Provider>
          }
        />
        {/* <Route path="/" element={<Navigate to="/screening" replace />} /> */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/forgot" element={<ForgotPass />} />
        <Route path="/resetPassword" element={<Newpass />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/twoFactor" element={<TwoFactorAuth />} />
        <Route path="/cancellation-policy" element={<CancellationPolicyPage />} />

        {userInfo.auth && (
          <>
            <Route path="/appointments" element={<AppointmentList />} />
            <Route path="/appointment/view" element={<ViewAppointment />} />
            <Route path="/appointment/rating" element={<ViewRating />} />
            <Route path="session" element={<Session />} />

            <Route path="/profile" element={<Profile />} />

          </>
        )}

        <Route path="/screening/*" element={<NewRouters />} />


        <Route path="/careTeam" element={<ProviderInfoPage />} />
        <Route path="/careTeam/:slug/:id" element={<DetailPhysicianPage />} />
        <Route path="/careTeam/:slug/:id/availability" element={<AvailabilityPage />} />
        <Route path="/careTeam/:slug/:id/payment" element={<PaymentPage />} />
        <Route path="/careTeam/:slug/:id/success" element={<SuccessPage />} />

        <Route path="/thankyou" element={<ThankYouPage />} />
      </Switch>
    </Suspense>

  );


};

export default Routes;
